if(!customElements.get('swym-wishlist-page')){
    class SwymWishlistPage extends HTMLElement{
        constructor(){
            super();
            window.initialPageLoaded = false; 
            document.addEventListener('swym:default-list-executed', this._initializeSwymComponent.bind(this));
        }
  
        _init(swat){
            this._initializeSelectors(swat);
            window.isShareWishlistPage ? this._renderShareWishlist(swat) : this._renderWishlist(swat);
            this._attachEventListeners();
        }
  
        /* General funcions */
  
        _initializeSwymComponent(){
          if(window.initialPageLoaded) return;
          window.initialPageLoaded = true; 
          if (!window.SwymCallbacks) window.SwymCallbacks = [];
          window.SwymCallbacks.push(this._init.bind(this));
        }
  
        _initializeSelectors (swat){
            this.swat = swat;
            this.body = document.body;
            this.settings = JSON.parse(this.dataset.settings);
            this.sectionId = this.dataset.sectionId;
            this.isShareWishlistPage = window.isShareListPage;
  
            /* Page Header Selectors */
  
            this.accountButton = this.querySelector('#swymcs-user-login-status-btn');
            this.accountButtonText = this.accountButton.querySelector('.swymcs-user-text.swym-value');
            this.accountPopup = this.querySelector('#swymcs-user-login-status-popup');
            this.accountPopupTitleText = this.accountPopup.querySelector('#swymcs-account-popup-title');
            this.accountPopupContentText1 = this.accountPopup.querySelector('#swymcs-account-info-1');
            this.accountPopupContentText2 = this.accountPopup.querySelector('#swymcs-account-info-2');
            this.accountPopupCloseButton = this.querySelector('#swymcs-close-account-popup');
            this.accountPopupCancelButton = this.querySelector('#swymcs-cancel-account-popup');
            this.accountPopupActionButton = this.querySelector('#swymcs-account-login-action-button');
            this.additionalOptionsMenuContainer = this.querySelector('#swymcs-addtional-options-menu-container');
  
            this.shareListAccountPopup = this.querySelector('#swymcs-share-list-login-status-popup');
            this.shareListAccountPopupTitleText = this.querySelector('#swymcs-share-list-account-popup-title');
            this.shareListAccountPopupContentText1 = this.querySelector('#swymcs-share-list-account-info-1');
            this.shareListAccountPopupContentText2 = this.querySelector('#swymcs-share-list-account-info-2');
            this.shareListAccountPopupCloseButton = this.querySelector('#swymcs-close-share-list-account-popup');
            this.shareListAccountPopupCancelButton = this.querySelector('#swymcs-cancel-share-list-account-popup');
            this.shareListAccountPopupActionButton = this.querySelector('#swymcs-share-list-account-login-action-button');
  
            /* Wishlist grid container */
  
            this.singleWishlistTitleText = this.querySelector('#swymcs-single-wishlist-container');
            this.emptyListContainer = this.querySelector('#swym-empty-wishlist-container');
            this.wishlistContainer = this.querySelector('#swymcs-wishlist-container');
            this.listsContainer = this.querySelector('#swymcs-lists-grid');
            this.listProductsContainer = this.querySelector('#swymcs-products-grid-container');
            this.productsContainer = this.querySelector('#swymcs-products-grid');
            this.wishlistHeader = this.querySelector('#swymcs-wishlist-header');
  
            /* Additional Options selectors */
  
            this.additionalOptionsContainer = this.querySelector('#swymcs-additional-options');
            this.additionalOptionsBtn = this.querySelector('#swymcs-view-additional-options');
            this.shareListButton = this.querySelector('#swymcs-share-list');
            this.deleteListButton = this.querySelector('#swymcs-delete-list');
            this.deleteListButtonText = this.deleteListButton.querySelector('.swymcs-share-button-text');
            this.deleteListButtonNew = this.querySelector('#swymcs-delete-list-btn-new');
            this.deleteListButtonNewText = this.deleteListButtonNew.querySelector('.swymcs-share-button-text');
  
            /* Additional Options popup selectors */
            this.additionalOptionsPopupContainer = this.querySelector('#swymcs-additional-options-popup-container');
            this.additionalOptionsPopupCloseButton = this.querySelector('#swymcs-close-additional-popup');
            this.additionalPopupCancelButtons = this.querySelectorAll('.swymcs-additonal-popup-cancel-button');
  
                /* Share List popup selectors */
                this.shareListPopup = this.querySelector('#swymcs-share-list-popup');
                this.shareLinkField = this.querySelector('#swymcs-share-link-field');
                this.shareNameField = this.querySelector('#swymcs-share-name-field');
                this.shareEmailField = this.querySelector('#swymcs-share-email-field');
                this.shareMessageField = this.querySelector('#swymcs-share-message-field');
                this.shareListError = this.querySelector('#swymcs-share-email-field-error');
                this.emailShareButton = this.querySelector('#swymcs-confirm-share-list');
                this.shareListPopupTitle = this.shareListPopup.querySelector('.swymcs-confirm-share-title');
                this.shareListPopupSenderNameLabel = this.shareListPopup.querySelector('[for="swymcs-share-name-field"]');
                this.shareListPopupSenderEmailLabel = this.shareListPopup.querySelector('[for="swymcs-share-email-field"]');
                this.shareListPopupSenderNotesLabel = this.shareListPopup.querySelector('[for="swymcs-share-message-field"]');
  
                /* Delete List popup selectors */
                this.deleteListPopup = this.querySelector('#swymcs-delete-list-popup');
                this.deleteListPopupContent = this.deleteListPopup.querySelector('.swymcs-popup-text.swymcs-popup-content');
                this.deleteListPopupTitleText = this.deleteListPopup.querySelector('.swymcs-confirm-delete-title');
                this.confirmDeleteListButton = this.querySelector('#swymcs-confirm-delete-list');
                this.deleteListPopupCancelBtn = this.querySelector('#swymcs-cancel-delete-list');
  
            this.pageLoader = this.querySelector('#swymcs-loader-container');
            this.wishlistSectionContainer = this.querySelector('.swymcs-wishlist-section-container');
            /* Wishlist Selectors for Strings */
  
            this.emptyListTitle = this.emptyListContainer.querySelector('#swym-empty-wishlist-container-title');
            this.emptyListDescription = this.emptyListContainer.querySelector('#swym-empty-wishlist-container-description');
            this.emptyListButton = this.emptyListContainer.querySelector('#swym-custom-continue-shopping');
  
            if(!window.isCustomer){
                this.guestMessageButton = this.querySelector('#swymcs-guest-user-btn');
            }
        }
  
        _attachEventListeners(){
  
            this.body.addEventListener('click', evt => this._overlayEvent(evt));
            this.addEventListener('swym:product-grid-loaded', this._updateLocaleStrings.bind(this));
  
            /* Adding events to page header elements */
  
            this.accountButton.addEventListener('click', evt => this._showPopupContainer(this.accountPopup));
            this.accountPopupCloseButton.addEventListener('click', evt => this._hidePopupContainer(this.accountPopup));
            this.accountPopupCancelButton.addEventListener('click', evt => this._hidePopupContainer(this.accountPopup));
            this.accountPopupActionButton.addEventListener('click', this._loginButtonAction.bind(this));
  
            this.shareListAccountPopupActionButton.addEventListener('click', this._loginButtonAction.bind(this));
            this.shareListAccountPopupCloseButton.addEventListener('click', evt => this._hidePopupContainer(this.shareListAccountPopup));
            this.shareListAccountPopupCancelButton.addEventListener('click', evt => this._hidePopupContainer(this.shareListAccountPopup));
  
            /* Additional Options Events */
            this.additionalOptionsBtn.addEventListener('click', evt => this._showPopupContainer(this.additionalOptionsContainer));
            this.additionalOptionsContainer.addEventListener('click', this._renderAdditionalOptionsPopup);
            this.shareListButton.addEventListener('click', this._renderShareListPopup.bind(this));
  
            /* Additional Options Popup Events */
            this.additionalPopupCancelButtons.forEach(btn => btn.addEventListener('click', this._closeAdditionalOptionsPopup.bind(this)));
            this.additionalOptionsPopupCloseButton.addEventListener('click', this._closeAdditionalOptionsPopup.bind(this));
  
                /* Share List Events */
                this.emailShareButton.addEventListener('click', this._shareListByEmail.bind(this));
                this.shareEmailField.addEventListener('input', this._validateEmail.bind(this));
  
                /* Delete List Events */
                this.confirmDeleteListButton.addEventListener('click', this._deleteList.bind(this));
  
            /* Lists grid buttons */
            this.productsContainer.addEventListener('click', this._eventsForProductsGrid);
            if(!window.isCustomer){
                this.guestMessageButton.addEventListener('click', this._loginButtonAction);
            }
            this.deleteListButtonNew.addEventListener('click', evt => this._renderDeleteList())
        }
  
        _updateLocaleStrings(){
            const swat = this.swat;
            const loggedInAccountPopupText = swat.retailerSettings.Strings.SaveListPopupLoggedInText.replace(/{{{?email}?}}/g, window.customerEmail);
            const shareListNotesLabel = swat.retailerSettings.Strings.ShareWishlistPopupNoteDefault.replace(/{{{?wishlistName}?}}/g, swat.retailerSettings.Strings.SingleWishlistTitle);
            this.ShareWishlistEmailSuccess = swat.retailerSettings.Strings.ShareWishlistEmailSuccess.replace(/{{{?wishlistName}?}}/g, swat.retailerSettings.Strings.SingleWishlistTitle);
  
            /* MENU CONTAINER BUTTONS */
            this.accountButtonText.textContent = window.isCustomer ? window.customerEmail : swat.retailerSettings.Strings.GuestShopperTitle;
            this.deleteListButtonText.textContent = swat.retailerSettings.Strings.WishlistContextMenuClearList;
            this.deleteListButtonNewText.textContent = swat.retailerSettings.Strings.WishlistContextMenuClearList;
            this.accountPopupTitleText.textContent = swat.retailerSettings.Strings.SaveListPopupSummaryHeading;
            this.singleWishlistTitleText.textContent = swat.retailerSettings.Strings.SingleWishlistTitle;
  
            /* NOT LOGGED IN CUSTOMER - ACCOUNT POPUP CONTAINER */
            this.accountPopupActionButton.textContent = window.isCustomer ? swat.retailerSettings.Strings.SaveListPopupLoggedInCTASave : swat.retailerSettings.Strings.SaveListPopupSummaryCTALogin;
            this.accountPopupContentText1.innerHTML = window.isCustomer ? loggedInAccountPopupText : swat.retailerSettings.Strings.SaveListPopupSummaryText;
            this.accountPopupCancelButton.textContent = swat.retailerSettings.Strings.SaveListPopupLoggedInCTACancel;
  
            /* DELETE LIST POPUP CONTAINER */
            this.deleteListPopupTitleText.textContent = swat.retailerSettings.Strings.ClearWishlistPopupHeading;
            this.confirmDeleteListButton.textContent = swat.retailerSettings.Strings.ClearWishlistPopupCTAClear;
            this.deleteListPopupCancelBtn.textContent = swat.retailerSettings.Strings.ClearWishlistPopupCTACancel;
  
            /* NOT LOGGED IN CUSTOMER - SHARE LIST POPUP CONTAINER */
            this.shareListAccountPopupTitleText.textContent = swat.retailerSettings.Strings.ShareWishlistLoginPopupHeading;
            this.shareListAccountPopupActionButton.textContent = swat.retailerSettings.Strings.SharedWishlistLoginCTA;
            this.shareListAccountPopupContentText1.textContent = swat.retailerSettings.Strings.ShareWishlistLoginPopupText;
            this.shareListAccountPopupContentText2.textContent = swat.retailerSettings.Strings.ShareWishlistLoginPopupMessage;
  
            /* SHARE LIST POPUP CONTAINER */
            this.shareListPopupTitle.textContent = swat.retailerSettings.Strings.ShareWishlistPopupHeading;
            this.shareListPopupSenderNameLabel.textContent = swat.retailerSettings.Strings.ShareWishlistSenderName;
            this.shareNameField.placeholder = swat.retailerSettings.Strings.ShareWishlistNamePlaceholder;
            this.shareListPopupSenderEmailLabel.textContent = swat.retailerSettings.Strings.ShareWishlistRecipientsEmail;
            this.shareEmailField.placeholder = swat.retailerSettings.Strings.ShareWishlistEmailPlaceholder;
            this.shareListPopupSenderNotesLabel.textContent = swat.retailerSettings.Strings.ShareWishlistMessage;
            this.shareMessageField.placeholder = swat.retailerSettings.Strings.ShareWishlistNotePlaceholder;
            this.shareMessageField.value = shareListNotesLabel;
            this.emailShareButton.textContent = swat.retailerSettings.Strings.ShareWishlistEmailCTA;
  
            /* EMPTY LIST CONTAINER */
            this.emptyListTitle.textContent = swat.retailerSettings.Strings.EmptyWishlistsHeading;
            this.emptyListDescription.textContent = swat.retailerSettings.Strings.EmptyWishlistsText;
            this.emptyListButton.textContent = swat.retailerSettings.Strings.EmptyWishlistsCTA;
  
            this._hideContainer(this.pageLoader);
            this._showContainer(this.wishlistSectionContainer);
        }
  
        async _renderWishlist(){
            this.lists = await this._getLists();
            this.lists.length ? this._renderSingleWishlist() : this._renderEmptyState();
        }
  
        async _renderShareWishlist(){
            const params = new URL(document.location).searchParams;
            const lid = params.get("lid");
            if(!lid){
                this._renderProductsGrid([]);
                this._hideContainer(this.wishlistHeader);
                this._showContainer(this.wishlistContainer);
                this._showContainer(this.listProductsContainer);
                return;
            }
            const wishlistProducts = await this._getProductsFromList(lid);
            const shopifyProductsData = await this._getShopifyProductsData(wishlistProducts);
            await this._renderSharedListHeader(lid);
            this._renderProductsGrid(shopifyProductsData);
            this._showContainer(this.wishlistContainer);
            this._showContainer(this.listProductsContainer);
        }
  
        async _renderSingleWishlist(){
            // window.currentActiveListId = window.currentActiveList?.lid;
            const wishlistProducts = await this._getProductsFromList(window.currentActiveListId);
            if(!wishlistProducts.length) {
                this._renderEmptyState();
                return;
            }
            this._hideContainer(this.emptyListContainer);
            const shopifyProductsData = await this._getShopifyProductsData(wishlistProducts);
            await this._renderSingleListHeader(window.currentActiveListId);
            this._renderProductsGrid(shopifyProductsData);
            this._showContainer(this.wishlistContainer);
            this._showContainer(this.listProductsContainer);
            this._showContainer(this.additionalOptionsMenuContainer);
        }
  
        _renderEmptyState(){
            this._hideContainer(this.additionalOptionsMenuContainer);
            this._showContainer(this.emptyListContainer);
            this._hideContainer(this.wishlistContainer);
            this.dispatchEvent(new CustomEvent('swym:product-grid-loaded'));
        }
  
        async _renderSharedListHeader(lid){
            this._hideContainer(this.additionalOptionsBtn);
            this._hideContainer(this.shareListButton);
        }
  
        async _renderSingleListHeader(lid){
            this._showContainer(this.additionalOptionsBtn);
            this._hideContainer(this.shareListButton);
        }
  
        _renderProductsGrid(products){
            if(!products.length) {
                this._renderEmptyState();
                return;
            }
            let productMarkup = ``;
            products.forEach(async (pdp, index) => {
                if(!pdp) return;
                const product = pdp.productData;
                const selectedVariant = product.variants.find(variant => variant.id === pdp.epi);
                const selectedVariantTitle = selectedVariant.title && selectedVariant.title.toLowerCase() != 'default title' ? ` - ${selectedVariant.title}` : '';
                const selectedVariantPrice = parseFloat(selectedVariant.price/100.00).toFixed(2);
                const selectedVariantCmpPrice = selectedVariant.compare_at_price &&  selectedVariant.compare_at_price != selectedVariant.price ? parseFloat(selectedVariant.compare_at_price/100.00).toFixed(2) : '';
                let addToCartBtnText = selectedVariant.available ? (_swat.platform.isInDeviceCart(selectedVariant.id) ? `${_swat.retailerSettings.Strings.AddToCartCTAAlreadyAdded}` : `${_swat.retailerSettings.Strings.AddToCartCTA}`) : `${_swat.retailerSettings.Strings.AddToCartCTACannotAdd}`;
                const inCart = _swat.platform.isInDeviceCart(selectedVariant.id) ? 'swymcs-product-in-cart' : '';
                const lid = pdp.lid;
                let isSoldOut = !selectedVariant.available ? 'swymcs-sold-out' : '';
                let isButtonDisabled = isSoldOut ? 'disabled': '';
                const imageSrc = selectedVariant?.featured_image?.src || product?.featured_image ||  pdp.iu;
                const imageSrc2 = product?.images[1] ? product?.images[1] : imageSrc;
                const productUrl = product.productUrl;
                let membersPrice = '';
                if(window.isLoyaltyMembersPricingEnabled){
                    const memberTag = product.tags.find(tag =>
                        tag.toLowerCase().includes('members:')
                    );
                    if (memberTag) { 
                        const discount = memberTag.split(':').pop();   
                        if (!discount) return;
                        const discountedPrice = (selectedVariantPrice * (1 - Number(discount) / 100)).toFixed(2);
                        membersPrice = `
                                    <div class="price__badge-members-only">
                                        <span class="members-price">${window.currencyCode}${discountedPrice}</span>
                                        <span class="members-percentage">(-${discount}%)</span><span class="hide-mobile"> - </span>
                                        ${window.customerHasSwellTier && window.isCustomer ? `<a class="members-copy" href="${window.vipLink}">${window.priceBadgeTextLoggedIn}</a>` : `<a class="members-copy" href="${window.vipLink}">${window.priceBadgeTextLoggedOut}</a>`}
                                        <span class="members-icon">
                                            <svg fill=none height=16 viewBox="0 0 23 16"width=23 xmlns=http://www.w3.org/2000/svg><path d="M21.5264 2.96002C19.8076 1.32723 16.6279 0.706584 14.8136 0.668391C14.7181 0.276905 14.2502 0 13.6582 0C13.0662 0 12.5983 0.276905 12.5028 0.668391C9.9437 0.687487 7.70927 1.35588 6.21011 2.55898C4.81598 3.67615 4.73959 8.40262 4.74914 10.0163C3.27862 10.341 0.137061 11.2003 0.00337721 12.5562C-0.0348181 13.0336 0.480818 13.3774 0.881869 13.5874C2.30464 14.3608 5.62763 15.2489 9.21799 15.4303C9.66678 15.4494 10.0965 15.4685 10.5166 15.4685H10.5644C13.1521 15.4685 16.7902 15.0483 19.3875 13.0623C19.7408 13.0145 22.2044 12.5848 22.9587 11.038V10.9807C22.9874 10.7229 23.3216 4.65964 21.5264 2.95047V2.96002ZM17.5732 3.51382C17.3058 2.67356 16.4464 1.98607 15.5966 1.4991C17.2676 1.67098 19.6835 2.29163 20.9917 3.52337C22.1948 4.66919 22.3381 8.60314 22.233 10.7706C21.6219 11.8592 19.4639 12.2793 19.3779 12.2984C18.9769 12.3366 18.5663 12.3748 18.1652 12.4034C18.5185 9.27153 17.9838 4.83151 17.5732 3.50428V3.51382ZM14.0497 1.59459C14.5462 1.79511 16.5037 2.65447 16.8379 3.74299C17.239 5.04157 17.7451 9.56753 17.3918 12.4512C13.515 12.6421 10.3161 12.1934 8.68326 11.8878C8.38724 6.67436 9.25618 4.49731 9.64769 3.80028C10.402 2.4635 12.7129 1.69007 13.1521 1.5564C13.4386 1.65188 13.7728 1.66143 14.0688 1.59459H14.0497ZM8.96017 3.42789C8.54002 4.17267 7.61379 6.46429 7.8907 11.735C7.44191 11.6395 7.04086 11.5345 6.7162 11.439C5.68493 11.1335 5.54169 10.3792 5.53214 10.3123C5.47485 7.95385 5.75177 3.91486 6.6971 3.15098C7.81431 2.25343 9.36122 1.69007 11.2137 1.4991C10.3543 1.93833 9.43761 2.56853 8.96017 3.41834V3.42789ZM17.7451 13.2055C13.0471 15.6881 5.36026 14.5423 2.14231 13.3201C1.09194 12.919 0.824576 12.6517 0.78638 12.6039C0.910515 12.0215 2.96351 11.2194 4.88282 10.7802C5.0547 11.2194 5.47485 11.8687 6.51567 12.1838C8.22491 12.6899 11.6147 13.2723 15.5489 13.2723C16.2841 13.2723 17.0194 13.2532 17.7546 13.2055H17.7451Z"fill=url(#paint0_linear_1_335) /><path d="M13.5821 4.25077L13.9956 6.53769L16.2985 6.85108L14.2512 7.95108L14.6648 10.238L12.986 8.63092L10.9387 9.73092L11.9484 7.63769L10.2695 6.03061L12.5724 6.344L13.5821 4.25077Z"fill=url(#paint1_linear_1_335) /><path d="M19.4857 5.27487L20.133 6.08966L21.108 5.72583L20.5331 6.59322L21.1804 7.408L20.1778 7.1293L19.6029 7.99668L19.5581 6.95704L18.5555 6.67834L19.5305 6.31451L19.4857 5.27487Z"fill=url(#paint2_linear_1_335) /><path d="M7.07294 5.06008L7.04864 5.65738L7.60923 5.86507L7.03363 6.02654L7.00933 6.62384L6.67789 6.12633L6.10229 6.2878L6.47304 5.81886L6.1416 5.32135L6.70218 5.52903L7.07294 5.06008Z"fill=url(#paint3_linear_1_335) /><defs><linearGradient gradientUnits=userSpaceOnUse id=paint0_linear_1_335 x1=11.5014 x2=11.5014 y1=0 y2=15.4685><stop stop-color=white /><stop stop-color=#999999 offset=1 /></linearGradient><linearGradient gradientUnits=userSpaceOnUse id=paint1_linear_1_335 x1=13.5821 x2=12.7194 y1=4.25077 y2=10.5898><stop stop-color=white /><stop stop-color=#999999 offset=1 /></linearGradient><linearGradient gradientUnits=userSpaceOnUse id=paint2_linear_1_335 x1=19.4857 x2=20.4872 y1=5.27487 y2=7.95864><stop stop-color=white /><stop stop-color=#999999 offset=1 /></linearGradient><linearGradient gradientUnits=userSpaceOnUse id=paint3_linear_1_335 x1=7.07294 x2=6.50126 y1=5.06008 y2=6.60319><stop stop-color=white /><stop stop-color=#999999 offset=1 /></linearGradient></defs></svg>
                                        </span>
                                    </div>
                                `;
                        }
                }
                productMarkup += `
                <li class="grid__item swymcs-product-card" data-page-index="1">
                    <product-card class="product-card " id="ProductGridProductCard${product.id}" data-item-index="1">
                        <div class="swymcs-wl-action-cta-container">
                            <button data-lid="${lid}" data-purpose="delete" data-epi="${selectedVariant.id}" data-empi="${product.id}" data-du="${pdp.du}" class="${this.isShareWishlistPage && 'swym-hide-container'} swymcs-has-after-css swymcs-button swymcs-product-delete-btn swym-nav swym-nav-1 swym-is-button" aria-label="${this.settings.swym_delete_list_text} ${product.title}">
                                <span class="swym-icon">${this.settings.swym_delete_list_icon}</span>
                            </button>
                        </div>
                        <div class="product-card__gallery product-card__gallery--no-gallery image-overlay" bis_skin_checked="1">
                            <img src="${imageSrc}" alt="${selectedVariant.title} Image" loading="lazy" fetchpriority="low" class="product-card__image motion-reduce"/>
                            <img src="${imageSrc2}" alt="${product.title} Image" loading="lazy" fetchpriority="low" class="product-card__image motion-reduce"/>
                        </div>
                        ${product.metafieldData.product_sub_title ? `
                            <div class="product-card__header" bis_skin_checked="1">
                                <p class="product-card__sub-title">${product.metafieldData.product_sub_title}</p>
                            </div>` : ''
                        }
                        <h2 class="product-card__heading" id="title-${this.sectionId}-${product.id}">
                            <a class="full-unstyled-link" href="${productUrl}" id="CardLink-${this.sectionId}-${product.id}" aria-labelledby="CardLink-${this.sectionId}-${product.id} Badge-${this.sectionId}-${product.id}">
                                <span>${product.title}${selectedVariantTitle}</span>
                            </a>
                        </h2>
                        <div class="price price--on-sale " bis_skin_checked="1">
                            <div class="price__container" bis_skin_checked="1">
                                <div class="price__sale" bis_skin_checked="1">
                                    <span class="price-item price-item--sale price-item--last">
                                        ${window.currencyCode}${selectedVariantPrice}
                                    </span>
                                    ${selectedVariantCmpPrice ? `
                                        <span>
                                            <s class="price-item price-item--regular">
                                                ${window.currencyCode}${selectedVariantCmpPrice}
                                            </s>
                                        </span>`
                                    : ''}
                                </div>
                            </div>
                        </div>
                        ${membersPrice}
                        <button ${isButtonDisabled} data-purpose="cart" data-du="${productUrl.split('?')[0]}" data-epi="${selectedVariant.id}" data-empi="${product.id}" class="swym-hide-container button button--primary ${inCart} ${isSoldOut} swymcs-major-button swymcs-has-after-css swymcs-add-to-cart-btn swymcs-button" aria-label="${addToCartBtnText}" data-variant-cost="${selectedVariantPrice}">
                                ${addToCartBtnText}
                        </button>
                        ${isButtonDisabled ? `<div class="badge__wrapper">
                            <div class="card__badge sold-out">
                                <span id="NoMediaCustomBadge---" class="badge">
                                    ${product.metafieldData.oos_badge_text}
                                </span>
                            </div>
                        </div>`: ''}
                        <product-form>
                            <template>
                                {
                                    "item_id": "p_${product.id}",
                                    "sku": "${selectedVariant.sku}",
                                    "item_name": "${product.title}",
                                    "price": ${selectedVariant.price},
                                    "quantity": 1,
                                    "affiliation": "Online Store",
                                    "item_category": "",
                                    "item_category2": "${product.metafieldData.item_category2}",
                                    "item_category_2": "${product.metafieldData.item_category_2}",
                                    "categories": "${product.metafieldData.categories}",
                                    "gender": "${product.metafieldData.gender}",
                                    "age_range": "${product.metafieldData.age_range}",
                                    "item_brand": "${product.metafieldData.item_brand}",
                                    "team": "${product.metafieldData.team}",
                                    "visor": "${product.metafieldData.visor}",
                                    "fit": "${product.metafieldData.fit}",
                                    "color": "${product.metafieldData.color}",
                                    "silhouette": "${product.metafieldData.silhouette}",
                                    "sport": "${product.metafieldData.sport}",
                                    "image_url": "${imageSrc}",
                                    "language": "${product.metafieldData.language}",
                                    "market": "${product.metafieldData.market}",
                                    "index": ${index},
                                    "locale": "${product.metafieldData.locale}"
                                }
                            </template>
                            <form method="post" action="/cart/add" id="quick-add-${this.sectionId}${selectedVariant.id}" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                                <input type="hidden" name="form_type" value="product">
                                <input type="hidden" name="utf8" value="✓">
                                <input type="hidden" name="id" value="${selectedVariant.id}">
                                <button ${isButtonDisabled} class="quick-add__submit button button--full-width button--outline dl-tracked" id="quick-add-${this.sectionId}${selectedVariant.id}-submit" type="submit" name="add" aria-haspopup="dialog" aria-labelledby="quick-add-${this.sectionId}${selectedVariant.id}-submit title-${this.sectionId}-${selectedVariant.id}" aria-live="polite" data-sold-out-message="true" title="Quick buy" data-tracking-event="button_click" data-tracking-text="Quick buy" data-tracking-action="Quick buy button clicked">
                                    <span class="label">Add to bag</span>
                                    <span class="label sold-out-message hidden">
                                        Sold out
                                    </span>
                                    <span class="icon icon-bag">
                                        <svg aria-hidden="true" focusable="false" class="icon icon-bag" width="14" height="16" viewBox="0 0 14 16" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 3.71429C4.5 2.18218 5.65122 1 7 1C8.34878 1 9.5 2.18218 9.5 3.71429V4H4.5V3.71429ZM3.5 5V7.5H4.5V5H9.5V7.5H10.5V5H13V15H1V5H3.5ZM3.5 4V3.71429C3.5 1.69599 5.03507 0 7 0C8.96493 0 10.5 1.69599 10.5 3.71429V4H13H14V5V15V16H13H1H0V15V5V4H1H3.5Z" fill="black"></path>
                                        </svg>
                                    </span>
                                    <div class="loading-overlay__spinner hidden" bis_skin_checked="1">
                                        <div class="loading-overlay__spinner " bis_skin_checked="1">
                                            <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                                            </svg>
                                        </div>
                                    </div>
                                </button>
                                <input type="hidden" name="product-id" value="${product.id}">
                                <input type="hidden" name="section-id" value="${this.sectionId}">
                            </form>
                        </product-form>
                    </product-card>
                </li>
                `;
            });
            this.productsContainer.innerHTML = productMarkup;
            this.productsContainer.classList.remove('swymcs-empty-list');
            // this._scrollToTop();
            this.dispatchEvent(new CustomEvent('swym:product-grid-loaded'));
        }
  
        _renderEmptyList(){
            this.productsContainer.classList.add('swymcs-empty-list');
            this.productsContainer.innerHTML = window.emptyListContent;
            this.productsContainer.querySelector('#swym-empty-wishlist-container').classList.remove('swym-hide-container');
        }
  
        async _renderShareListPopup(evt){
            this._closeAdditionalOptionsPopup();
            this._renderShareList();
        }
  
        async _renderAdditionalOptionsPopup (evt) {
            const page = document.querySelector('swym-wishlist-page');
            const target = evt.target;
            if(target.id == 'swymcs-additional-options') return;
            page._hidePopupContainer(page.querySelector('.swym-active-popup'));
            const action = target.dataset.action;
            page._closeAdditionalOptionsPopup();
            if(action == 'share') page._renderShareList();
            else if(action == 'delete') page._renderDeleteList();
        }
  
        _closeAdditionalOptionsPopup () {
            this._hideContainer(this.shareListPopup);
            this._hideContainer(this.deleteListPopup);
            this._hidePopupContainer(this.additionalOptionsPopupContainer);
        }
  
        async _renderShareList() {
            if(!window.isCustomer) {
                this._showPopupContainer(this.shareListAccountPopup);
                return;
            }
            // const list = await this._markListAsPublic();
            const shareableLink = await this._prepareShareLink();
            this.shareLinkField.textContent = shareableLink;
            this._showContainer(this.shareListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
        }
  
        _renderDeleteList () {
            this.deleteListString = _swat.retailerSettings.Strings.ClearWishlistPopupConfirmMessage.replace(/{{{?listName}?}}/g, `<span class="swymcs-highlighted-popup-text" id="swymcs-confirm-delete-list-name">${this.swat.retailerSettings.Strings.SingleWishlistTitle}</span>`);
            this.deleteListPopupContent.innerHTML = this.deleteListString;
            this._showContainer(this.deleteListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
        }
  
        /* Show / Hide containers */
  
        _overlayEvent(evt){
            if (evt.target.nodeName == 'BODY') {
                this.querySelectorAll(".swym-active-popup").forEach(popup => this._hidePopupContainer(popup));
              }
        }
  
        _scrollToTop () {
            const header = document.querySelector('.swymcs-page-header');
            if (header) {
                var targetOffsetTop = header.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({
                    top: targetOffsetTop,
                    behavior: "smooth"
                });
            }
        }
  
        _showPopupContainer (selector) {
            selector.classList.remove('swym-hide-container');
            selector.classList.add('swym-active-popup');
            this.body.classList.add('no-scroll');
        }
  
        _hidePopupContainer (selector) {
            selector.classList.add('swym-hide-container');
            selector.classList.remove('swym-active-popup');
            this.body.classList.remove('no-scroll');
        }
  
        _showContainer (selector) {
            selector.classList.remove('swym-hide-container');
        }
  
        _hideContainer (selector) {
            selector.classList.add('swym-hide-container');
        }
  
        /* Javascript APIs related functions */
        _getLists () {
            return new Promise(async (resolve, reject) => {
                this.swat.fetchLists({
                  callbackFn: lists => resolve(lists),
                  errorFn: err => reject(err)
                });
            });
        }
  
        _getListDetails(lid){
            return new Promise(async (resolve, reject) => {
                this.swat.fetchListDetails(
                  { lid: lid },
                  list => resolve(list),
                  error => reject(error)
                );
            });
        }
  
        _getProductsFromList(lid){
            return new Promise(async (resolve, reject) => {
                this.swat.fetchListCtx(
                  { lid: lid },
                  listContents => resolve(listContents),
                  error => reject(error)
                );
            });
        }
  
        async _getShopifyProductsData(products){
            const section = this;
            if(!products.length) return [];
            let buggedProductsArray = [];
            let response = await Promise.all(products.map(async (product) => {
                try{
                    const [storeUrlString, productHandleString] = product.du.split('/products/');
                    const productHandle = productHandleString.split('?')[0];
                    const reqURL = `${storeUrlString}${Shopify.routes.root}products/${productHandle}`;
                    const jsonData = await JSON.parse(await section._fetchTranslatedProductData(reqURL));
                    jsonData.productUrl = `${storeUrlString}${Shopify.routes.root}products/${jsonData.handle}?variant=${product.epi}`;
                    jsonData.metafieldData = await JSON.parse(await section._fetchProductMetafieldsData(reqURL));
                    product.productData = jsonData;
                    return product;
                }
                catch(error){
                    const errorObj = {};
                    errorObj[product.du] = error;
                    buggedProductsArray.push(errorObj);
                    return null;
                }
            }));
            response = response.filter(product => product && product.productData);
            return response;
        }
  
        async _fetchTranslatedProductData(url){
            const sectionHtml=await(await fetch(`${url}?section_id=swym-translated-product-data`)).text();
            const productDataHTML = new DOMParser().parseFromString(sectionHtml,"text/html").getElementById("swym-translated-product-data").textContent;
            return productDataHTML;
        }
  
        async _fetchProductMetafieldsData(url){
            const sectionHtml=await(await fetch(`${url}?section_id=swym-translated-product-data`)).text();
            const productDataHTML = new DOMParser().parseFromString(sectionHtml,"text/html").getElementById("swym-product-metafields-data").textContent;
            return productDataHTML;
        }
  
        _deleteProductFromList(product, lid, parentNode){
            const onSuccess = async deletedProduct => {
                parentNode.remove();
                if(!this.productsContainer.querySelector('.swymcs-product-card')){
                    this._renderProductsGrid([]);
                }
                this.lists = await this._getLists();
            }
            const onError = error => console.error("Error while deleting the Product", error)
            this.swat.deleteFromList(lid, product, onSuccess, onError);
        }
  
        async _deleteList(){
            try {
                window.currentActiveListId = '';
                window.listProductsCount = 0;
                swymCustomFunctions.updateHeaderCounter();
                await swymCustomFunctions.deleteLists(_swat, this.lists);
                this._closeAdditionalOptionsPopup();
                this._renderWishlist(_swat);
            } catch (error) {
                console.error(`Error while deleting the List -`, error);
            }
        }
  
        _validateListName(name, errorField){
            const isValidList = false;
            if(name.length < 3){
                errorField.textContent = 'Name must be longer than 3 characters';
                return isValidList;
            }
            const lists = this.lists;
            const matchedList = lists.find(list => list.lname.trim().toLowerCase() == name);
            if(matchedList) {
                errorField.textContent = 'List name already exists';
                return isValidList;
            }
            errorField.textContent = '';
            return !isValidList;
        }
  
        _validateEmail() {
            const emailPattern = /^\w+([.-]\w+)*@\w+([.-]\w+)*(\.\w{2,4})+$/;
            const isBlank = this.shareEmailField.value=='' ? true : false;
            const isInvalidString = !this.shareEmailField.value.match(emailPattern) ? true : false;
            if(isBlank || isInvalidString){
                // this.shareListError.textContent = isBlank ? 'Please enter the email address' : 'Please enter a valid email address';
                this.shareListError.textContent = this.swat.retailerSettings.Strings.ValidationErrorEmail;
                return false;
            }
            this.shareListError.textContent = '';
            return true;
        }
  
        _markListAsPublic(){
            return new Promise(async (resolve, reject) => {
                this.swat.markListPublic(window.currentActiveListId,
                    list => resolve(list),
                    err => reject(err)
                );
            });
        }
  
        _prepareShareLink(){
            return new Promise(async (resolve, reject) => {
                this.swat.generateSharedListURL(window.currentActiveListId,
                    (link, lid) => resolve(link, lid),
                    err => reject(err)
                );
            });
        }
  
        _shareListByEmail(){
            const email = this._validateEmail();
            if(!email) return;
            const onSuccess = response => {
                const imageUrl = response.listinfo.listcontents[0]?.iu || response.listinfo.listContents[1]?.iu;
                const html = `
                    <style>
                        .swym-notification-success-inner .swym-image{ display: none !important }
                        #swym-custom-notification-content { display: flex; gap: 10px; align-items: center; cursor: pointer }
                        #swym-custom-notification-content #swym-custom-image-container { position: relative; min-height: 96px; min-width: 96px; max-height: 96px; max-width: 96px; background-color: #F5F5F5 }
                        #swym-custom-notification-content #swym-custom-image-container #swym-custom-image { width: 100%; height: 100%; object-fit: cover; mix-blend-mode: multiply !important }
                        #swym-custom-notification-content #swym-custom-title-container { font-weight: 500; font-size: 14px }
                        .swym-notification-success-inner, .swym-notification-success-inner .swym-details-container .swym-details { padding: 0 !important }
                    </style>
                    <div id="swym-custom-notification-content">
                        <div id="swym-custom-image-container">
                            <img id="swym-custom-image" src="${imageUrl}" alt="wishlisted product image"/>
                        </div>
                        <div id="swym-custom-title-conatainer">${this.ShareWishlistEmailSuccess}</div>
                    </div>
                `;
                _swat.ui.uiRef.showSuccessNotification({ message: `${html}` });
                this._closeAdditionalOptionsPopup();
            }
            const onError = error => _swat.ui.uiRef.showErrorNotification({message: this.swat.retailerSettings.Strings.ShareWishlistEmailError});
            _swat.sendListViaEmail({
                'toEmailId': this.shareEmailField.value.trim(),
                'note': this.shareMessageField.value,
                'fromName': this.shareNameField.value,
                'lid': window.currentActiveListId,
            }, onSuccess, onError);
        }
  
        /* Header functions */
  
        _loginButtonAction(evt){
            // const redirectionUrl = evt.currentTarget.getAttribute('data-redirection-url');
            const actionUrl = evt.currentTarget.getAttribute('data-action-url');
            // localStorage.setItem('SWYM_REDIRECT_URL', redirectionUrl);
            // localStorage.setItem('SWYM_ACTION_URL', actionUrl);
            location.href = actionUrl;
        }
  
        /* Product Grid Events */
  
        async _eventsForProductsGrid (evt) {
            const target = evt.target;
            const page = document.querySelector('swym-wishlist-page');
            const purpose = target.dataset?.purpose;
            if(!purpose) return;
            evt.preventDefault();
            if (purpose == 'delete'){
                page._deleteProductFromList(
                    {
                        "epi": target.dataset.epi,
                        "empi": target.dataset.empi,
                        "du": target.dataset.du
                    }, target.dataset.lid, target.closest('.swymcs-product-card')
                );
            }
        }
    }
    customElements.define('swym-wishlist-page', SwymWishlistPage);
  }